import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-info',
  templateUrl: './home-page-info.component.html',
  styleUrls: ['./home-page-info.component.scss']
})
export class HomePageInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
